import React from 'react';

export const FilesDownload = ({ fill = 'black', width = 16, height = 16 }) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8.01597 11.5C8.21299 11.5001 8.40809 11.4614 8.59014 11.386C8.77219 11.3107 8.93762 11.2003 9.07697 11.061L11.0365 9.1L10.3295 8.395L8.51297 10.212L8.49997 2H7.49997L7.51297 10.204L5.70297 8.394L4.99597 9.1L6.95547 11.0595C7.09465 11.199 7.25994 11.3097 7.4419 11.3853C7.62386 11.4608 7.81893 11.4998 8.01597 11.5Z"
            fill={fill}
        />
        <path
            d="M13 10V12.5C13 12.6326 12.9473 12.7598 12.8536 12.8536C12.7598 12.9473 12.6326 13 12.5 13H3.5C3.36739 13 3.24021 12.9473 3.14645 12.8536C3.05268 12.7598 3 12.6326 3 12.5V10H2V12.5C2 12.8978 2.15804 13.2794 2.43934 13.5607C2.72064 13.842 3.10218 14 3.5 14H12.5C12.8978 14 13.2794 13.842 13.5607 13.5607C13.842 13.2794 14 12.8978 14 12.5V10H13Z"
            fill={fill}
        />
    </svg>
);
